import React, { FC } from 'react'
import { FormHelperText, FormHelperTextProps } from '@mui/material'

const EvtFormHelperText: FC<FormHelperTextProps> = ({ children, ...props }) => {
    return <FormHelperText {...props}>{children}</FormHelperText>
}

export default EvtFormHelperText
